import { useRef } from 'react';
import { Stack, TextField, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';

export default function AddVstDevice() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const vstDeviceRef = useRef();
  const handleSubmit = () => {
    const vstHost = vstDeviceRef.current.value;
    enqueueSnackbar(`Pending - add ${window.adaptorType} host ${vstHost}`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    axiosInstance
      .post(`${window.location.protocol}//${vstHost}/api/v1/sensor/version`)
      .then(async () => {
        enqueueSnackbar(`Pending - ${window.adaptorType} host ${vstHost} validated`, {
          variant: 'info',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        dispatch(appSliceActions.addVstHost(vstHost));
        const sensorList = await fetchDeviceList(vstHost);
        if (sensorList != null) {
          for (let i = 0; i < sensorList.length; i += 1) {
            sensorList[i].host = vstHost;
          }
          dispatch(appSliceActions.addDevice(sensorList));
        }
        const streamList = await fetchStreamList(vstHost);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = vstHost;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
        enqueueSnackbar(`Success - ${window.adaptorType} host ${vstHost} added`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      })
      .catch((error) => {
        enqueueSnackbar(`Error - Failed to validate ${window.adaptorType} host ${vstHost}`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <TextField name="vst-host" label={`${window.adaptorType} host`} inputRef={vstDeviceRef} />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Submit
        </LoadingButton>
      </Box>
    </>
  );
}
